import { css } from '@emotion/css';

export const addPageBlock = css`
	display: flex;
	justify-content: space-between;
`;
